<sn-fab-button
  class="actions"
  [matTooltip]="'common.actions' | t"
  [matMenuTriggerFor]="menu"
  (menuOpened)="menuOpen = true"
  (menuClosed)="menuOpen = false"
  [ngClass]="{ gray: !camera.playbackUrls }"
  #trigger="matMenuTrigger"
  *ngIf="
    (actions || menuOpen) &&
    isSessionActive &&
    camera?.liveVideoUrls &&
    !isCitizen &&
    !isVerkadaCloudToCloud
  "
>
  <sn-icon>menu</sn-icon>
</sn-fab-button>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    *ngIf="!isPursuit && camera?.geometry && camera.status !== 'Down'"
    (click)="hotPursuit(camera)"
  >
    <sn-icon fontSet="fal" fontIcon="fa-crosshairs-simple"></sn-icon>
    {{ 'map.camera.actions.overwatch' | t }}
  </button>
  <button mat-menu-item *ngIf="!sharedIn() && (canEdit || canChange)" (click)="editCamera(camera)">
    <sn-icon fontSet="fal" fontIcon="fa-pen"> </sn-icon> {{ 'map.camera.actions.editCamera' | t }}
  </button>
  <button
    mat-menu-item
    *ngIf="
      camera.discoveryUrls?.ptzMoveUrls &&
      (camera.shareInfo?.permissionsDetails?.enablePtzControl || !camera.isShared)
    "
    class="ptz"
    (click)="toggleFullscreen(true)"
  >
    <sn-icon fontSet="fal" fontIcon="fa-arrows-up-down-left-right"></sn-icon> {{ 'common.ptz' | t }}
  </button>
  <button mat-menu-item (click)="openChannel()">
    <sn-icon fontSet="fal" fontIcon="fa-reply"></sn-icon> {{ 'common.shareInChat' | t }}
  </button>
  <button
    mat-menu-item
    *ngIf="
      camera.playbackUrls &&
      (!camera.isShared || camera.shareInfo?.permissionsDetails.viewPlayback) &&
      canClip &&
      camera.canExportVideo
    "
    (click)="createClip(camera)"
  >
    <sn-icon fontSet="fal" fontIcon="fa-film"></sn-icon>{{ 'common.createClip' | t }}
  </button>
  <button mat-menu-item *ngIf="camera.isAiEnabled && this.allowAi" (click)="openSentrySearch()">
    <sn-icon fontSet="fal" fontIcon="fa-magnifying-glass"></sn-icon>
    {{ 'common.searchDetections' | t }}
  </button>
  <button mat-menu-item *ngIf="canAddWidget" (click)="addToDashboard()">
    <sn-icon fontSet="fal" fontIcon="fa-grid-2-plus"></sn-icon>
    {{ 'common.addToDashboard' | t }}
  </button>
  <button mat-menu-item *ngIf="canEdit" (click)="reportCameraIssue(camera.id)">
    <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation"></sn-icon>
    {{ 'map.camera.actions.reportIssue' | t }}
  </button>
  <button mat-menu-item *ngIf="operationalActions" (click)="openOpGridDialog()">
    <sn-icon fontSet="fal" fontIcon="fa-arrow-right-arrow-left"></sn-icon>
    {{ 'cameras.stream.actions.changeCamera' | t }}
  </button>
  <button mat-menu-item *ngIf="!isOnMap && camera?.geometry" (click)="goToCamera(camera)">
    <sn-icon fontSet="fal" fontIcon="fa-location-dot"></sn-icon>
    {{ 'common.goToCamera' | t }}
  </button>
</mat-menu>

<ng-template [ngIf]="!isPlayingConfirmed">
  <sn-alert type="warning">
    <p>
      {{ 'cameras.stream.messages.cellularConnection' | t }}
    </p>
    <sn-outline-button color="warning" (click)="confirmPlaying()">{{
      'common.play' | t
    }}</sn-outline-button>
  </sn-alert>
</ng-template>

<ng-template [ngIf]="!isSessionActive && !localPlaying">
  <div class="streamSessionEnded">
    <p>{{ 'cameras.stream.messages.sessionExpired' | t }}</p>
    <button mat-flat-button color="accent" (click)="reinitialize()">
      {{ 'cameras.stream.actions.restartStream' | t }}
    </button>
  </div>
</ng-template>

<ng-template [ngIf]="camera?.isRestricted && camera?.isRestrictionActive" [ngIfElse]="allowed">
  <div class="is-restricted">
    <div class="restricted-wrapper camera-stream-view-text-center camera-stream-view-pt-2">
      <sn-icon class="camera-stream-view-p-1">videocam_off</sn-icon>
      <p *ngIf="camera?.isRestricted && camera?.isRestrictionActive">
        {{ 'cameras.stream.messages.restricted' | t }}
      </p>
      <p *ngIf="!camera?.isRestrictionActive && camera?.isRestricted">
        {{ 'cameras.stream.messages.pending' | t }}
      </p>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="!camera?.liveVideoUrls && (camera.isManaged || isExternal)">
  <div class="is-restricted">
    <div class="restricted-wrapper camera-stream-view-text-center camera-stream-view-pt-2">
      <sn-icon class="camera-stream-view-p-1">videocam_off</sn-icon>
      <p>{{ 'map.livestream.noPermission' | t }}</p>
    </div>
  </div>
</ng-template>

<ng-template #allowed>
  <ng-container *ngIf="camera?.externalType === 'verkadac2c'; else bosch">
    <lib-verkada-player
      [camera]="camera"
      [caption]="caption"
      [autoplay]="autoplay"
      [isFullscreen]="isFullscreen"
      (fullscreenChange)="onFullscreenChange($event)"
    ></lib-verkada-player>
  </ng-container>
</ng-template>

<ng-template #bosch>
  <ng-container *ngIf="camera?.deepIntegrationMake === 'bosch'; else normal">
    <fs-bosch-player
      #boschPlayer
      [src]="camera"
      width="100%"
      [aspectRatio]="ASPECT_RATIO.Classic"
      [caption]="caption"
      [autoplay]="autoplay"
      [ptzConfig]="ptzConfig"
      [showCalendar]="showCalendar"
      [alwaysOn]="alwaysOn"
      (fullscreenChange)="onFullscreenChange($event)"
    >
      <sn-ptz-controls-component
        [ptzConfig]="ptzConfig"
        *ngIf="camera.shareInfo?.permissionsDetails?.enablePtzControl || !camera.isShared"
      >
      </sn-ptz-controls-component>
      <sn-player-footer-section>
        <sn-player-play-control></sn-player-play-control>
        <sn-player-volume-control></sn-player-volume-control>
        <sn-player-source-toggle-control
          [liveUrls]="camera.liveVideoUrls"
        ></sn-player-source-toggle-control>
        <button
          class="calendar"
          *ngIf="isFullscreen"
          mat-icon-button
          (click)="toggleCalendar()"
          [color]="showCalendar ? 'accent' : null"
          [matTooltip]="'cameras.stream.tooltips.toggleCalendar' | t"
        >
          <sn-icon size="md">date_range</sn-icon>
        </button>
        <sn-video-player-screenshot
          [camera]="camera"
          [alwaysOn]="alwaysOn"
        ></sn-video-player-screenshot>
      </sn-player-footer-section>
      <sn-player-footer-section alignment="end">
        <sn-player-fullscreen-control></sn-player-fullscreen-control>
      </sn-player-footer-section>
    </fs-bosch-player>
  </ng-container>
</ng-template>

<ng-template #normal>
  <ng-template [ngIf]="isCitizen && !camera.isLive">
    <div class="players citizen-player">
      <div class="localPlayer player">
        <sn-video-player
          #citizenPlayer
          #videoPlayer
          [src]="camera?.liveVideoUrls?.main?.cloud"
          [camera]="camera"
          [autoplay]="autoplay"
          [aspectRatio]="ASPECT_RATIO.Classic"
          [caption]="caption"
          [muted]="true"
          (fullscreenChange)="onCitizenFullscreenChange($event)"
          width="100%"
        >
          <sn-player-footer-row class="fullscreenControls">
            <div *ngIf="isFullscreen">
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.backFiveSeconds' | t"
                (click)="back(5)"
              >
                <sn-icon>replay_5</sn-icon>
              </sn-icon-button>
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.backHalfSecond' | t"
                (click)="back(0.5)"
              >
                <sn-icon>skip_previous</sn-icon>
              </sn-icon-button>
              <sn-icon-button [matTooltip]="'common.videoPlayer.rewind' | t" (click)="rewind()">
                <sn-icon>fast_rewind</sn-icon>
              </sn-icon-button>
              <sn-player-play-control></sn-player-play-control>
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.fastForward' | t"
                (click)="fastForward()"
              >
                <sn-icon>fast_forward</sn-icon>
              </sn-icon-button>
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.forwardHalfSecond' | t"
                (click)="forward(0.5)"
              >
                <sn-icon>skip_next</sn-icon>
              </sn-icon-button>
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.forwardFiveSeconds' | t"
                (click)="forward(5)"
              >
                <sn-icon>forward_5</sn-icon>
              </sn-icon-button>
              <sn-icon-button
                [matTooltip]="'common.videoPlayer.takeScreenshot' | t"
                (click)="citizenScreenshot()"
              >
                <sn-icon>content_cut</sn-icon>
              </sn-icon-button>
              <span
                class="playbackRate"
                *ngIf="
                  (isCitizenFastForwarding && playbackRate > 1) ||
                  (isCitizenRewinding && citizenRewindSpeedFactor > 0)
                "
                [class.forward]="isCitizenFastForwarding"
                [class.rewind]="isCitizenRewinding"
                >x
                <ng-container *ngIf="isCitizenFastForwarding && playbackRate > 1">{{
                  playbackRate
                }}</ng-container>
                <ng-container *ngIf="isCitizenRewinding && citizenRewindSpeedFactor > 0">{{
                  citizenRewindSpeedFactor
                }}</ng-container>
              </span>
            </div>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <sn-player-progress-bar-control></sn-player-progress-bar-control>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <sn-player-footer-section>
              <sn-player-play-control></sn-player-play-control>
              <sn-player-volume-control></sn-player-volume-control>
              <sn-player-time-control></sn-player-time-control>
              <sn-icon-button
                *ngIf="isFullscreen"
                [class.digiZoomActive]="isDigiZoomActive"
                (click)="toggleDigiZoom()"
                [matTooltip]="
                  isDigiZoomActive
                    ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                    : ('common.videoPlayer.toggleDigitalZoomOn' | t)
                "
              >
                <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
              </sn-icon-button>
            </sn-player-footer-section>
            <sn-player-footer-section alignment="end">
              <div class="playback">
                <div>
                  <mat-slider
                    class="playbackSlider"
                    *ngIf="isFullscreen && player.reference"
                    [displayWith]="getLabel"
                    [thumbLabel]="true"
                    [tickInterval]="0.1"
                    [step]="0.1"
                    [min]="0.1"
                    [max]="2"
                    [value]="player.reference.playbackRate"
                    [(ngModel)]="player.reference.playbackRate"
                  >
                  </mat-slider>
                </div>
              </div>
              <sn-icon-button
                class="citizen-popup"
                *ngIf="!isFullscreen"
                [matTooltip]="'cameras.stream.tooltips.openPopup' | t"
                (click)="openCitizenPopup()"
              >
                <sn-icon fontSet="far" fontIcon="fa-circle-info"></sn-icon>
              </sn-icon-button>
              <sn-player-fullscreen-control></sn-player-fullscreen-control>
            </sn-player-footer-section>
          </sn-player-footer-row>
        </sn-video-player>
      </div>
    </div>
  </ng-template>

  <ng-template
    [ngIf]="
      (!isUnmanagedStreamActive && !!camera.liveVideoUrls && !hasFmp4 && !isCitizen) ||
      (isCitizen && camera.isLive)
    "
  >
    <div class="players">
      <div class="localPlayer player">
        <div *ngIf="timelineTime && showPlaybackMessage" class="noplayback">
          {{ 'cameras.stream.messages.noPlaybackAvailable' | t }}
        </div>
        <sn-video-player
          [class.hidePlayback]="timelineTime && showPlaybackMessage"
          #localPlayerRef
          #videoPlayer
          [autoplay]="autoplay"
          [src]="src"
          [camera]="camera"
          [caption]="caption"
          [elevation]="camera.elevation"
          [live]="true"
          [muted]="true"
          [loopDuration]="camera.loopDuration"
          [controls]="controls"
          [aspectRatio]="ASPECT_RATIO.Classic"
          [ptzConfig]="ptzConfig"
          [local]="true"
          [cloudTimeout]="cloudTimeout"
          [subEnabled]="camera.isSubEnabled"
          [timestamp]="timestamp"
          [isFlv]="isFlv"
          [alwaysOn]="alwaysOn"
          [isFususCamera]="isFususCamera"
          [isFmp4Src]="hasFmp4"
          [camId]="camera.id"
          width="100%"
          [time]="time"
          (init)="onLocalPlayerInit($event)"
          (stateChange)="onStateChange($event)"
          (fullscreenChange)="onFullscreenChange($event)"
          (playerError)="onPlayerError($event)"
        >
          <ng-container snPlayerContent>
            <sn-camera-ws-overlay
              [matTooltip]="'cameras.stream.tooltips.toggleMotionEvents' | t"
              [wsUrl]="camera.liveVideoUrls.main?.local?.wssEvents"
              *ngIf="
                localPlayerRef?.live &&
                isFullscreen &&
                camera.liveVideoUrls.main?.local?.wssEvents &&
                localPlayerRef?.showEvents
              "
            ></sn-camera-ws-overlay>
          </ng-container>
          <sn-ptz-presets-component
            [ptzConfig]="ptzConfig"
            [local]="true"
            [class.hideWhilePtzDragging]="isPtzDragging"
          ></sn-ptz-presets-component>
          <sn-ptz-controls-component
            [ptzConfig]="ptzConfig"
            (dragging)="onPtzDrag($event)"
            [local]="true"
            *ngIf="
              isQognify ||
              camera.shareInfo?.permissionsDetails?.enablePtzControl ||
              !camera.isShared
            "
          ></sn-ptz-controls-component>
          <sn-video-player-analysis
            *ngIf="playerRef"
            (toggleCalendar)="toggleCalendar()"
            [camera]="camera"
            [alwaysOn]="alwaysOn"
            [ptzConfig]="ptzConfig"
            [class.hideWhilePtzDragging]="isPtzDragging"
          ></sn-video-player-analysis>
          <sn-player-footer-row
            class="camera-stream-view-mb-3"
            *ngIf="isLoadingTimeline && isFullscreen && !cameraTimeline"
          >
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <div class="timelineControls" [class.hideWhilePtzDragging]="isPtzDragging">
              <mat-calendar
                *ngIf="cameraTimeline && showCalendar && (isFullscreen || alwaysOn)"
                class="calendar availability"
                #calendar
                [(selected)]="date"
                [dateFilter]="hasRecordings"
                (selectedChange)="dateChange()"
              ></mat-calendar>
            </div>
            <fs-timeline
              class="videoPlayerTimeline"
              #recordingTimeline
              *ngIf="
                ((playerRef && cameraTimeline && isFullscreen && !isUbicquia) ||
                  alwaysOn ||
                  (showAvailableRecordings && isFullscreen && cameraTimeline)) &&
                !isLoadingTimeline
              "
              [currentTime]="time"
              [currentDate]="date"
              [height]="timelineHeight"
              [fullscreen]="isFullscreen"
              (dragging)="dragging($event)"
              (moveCursor)="moveCursor($event)"
              (brush)="onBrush($event)"
              [timelineDefinition]="cameraTimeline"
              (segment)="activateSegment($event)"
              (zoom)="onTimelineZoom($event)"
              (userSeeking)="onUserSeeking($event)"
              [prerecordingUrls]="camera.playbackUrls?.main?.local"
              [class.hideWhilePtzDragging]="isPtzDragging"
            >
            </fs-timeline>
            <sn-video-player-progress
              [class.showTimestamp]="
                camera.playbackUrls?.main?.local &&
                (!isFullscreen || (showAvailableRecordings && !cameraTimeline)) &&
                !alwaysOn &&
                !isUbicquia
              "
              [prerecordingUrls]="camera.playbackUrls?.main?.local"
              [liveUrls]="camera.liveVideoUrls"
            >
            </sn-video-player-progress>
          </sn-player-footer-row>
          <sn-player-footer-section>
            <sn-player-play-control></sn-player-play-control>
            <sn-player-volume-control></sn-player-volume-control>
            <sn-player-source-toggle-control
              [liveUrls]="camera.liveVideoUrls"
            ></sn-player-source-toggle-control>
            <sn-icon-button
              *ngIf="
                (!ptzOn && (isFullscreen || alwaysOn)) ||
                (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
              "
              [class.digiZoomActive]="isDigiZoomToggled"
              class="digiZoomToggle"
              (click)="toggleDigiZoom()"
              [matTooltip]="
                isDigiZoomToggled
                  ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                  : ('common.videoPlayer.toggleDigitalZoomOn' | t)
              "
            >
              <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
            </sn-icon-button>
            <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
            <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
              {{ time | fsFormatDate : 'long' }}
            </span>
            <div
              class="timelineLoadFailed"
              *ngIf="isFullscreen && !cameraTimeline && !isLoadingTimeline"
            >
              <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation"></sn-icon>
              <span class="ml-1">{{ 'cameras.stream.messages.timelineLoadFailed' | t }}</span>
              <sn-icon-button
                class="retryTimeline"
                (click)="retryTimeline()"
                [matTooltip]="'cameras.stream.tooltips.reloadTimeline' | t"
              >
                <sn-icon fontSet="far" fontIcon="fa-repeat"></sn-icon>
              </sn-icon-button>
            </div>
          </sn-player-footer-section>
          <sn-player-footer-section alignment="end">
            <sn-icon class="indicator local" fontSet="fa" fontIconUnicode="f6ff"></sn-icon>
            <sn-player-fullscreen-control></sn-player-fullscreen-control>
          </sn-player-footer-section>
        </sn-video-player>
      </div>
      <div
        class="cloudPlayer player"
        *ngIf="!localPlaying"
        [class.noLocalStream]="!src?.main?.local"
      >
        <div *ngIf="timelineTime && showPlaybackMessage" class="noplayback">
          {{ 'cameras.stream.messages.noPlaybackAvailable' | t }}
        </div>
        <sn-video-player
          [class.hidePlayback]="timelineTime && showPlaybackMessage"
          #videoPlayer
          #cloudPlayerRef
          [autoplay]="autoplay"
          [src]="src"
          [camera]="camera"
          [caption]="caption"
          [elevation]="camera.elevation"
          [live]="true"
          [muted]="true"
          [loopDuration]="camera.loopDuration"
          [controls]="controls"
          [aspectRatio]="ASPECT_RATIO.Classic"
          [ptzConfig]="ptzConfig"
          [local]="false"
          [cloudTimeout]="cloudTimeout"
          [subEnabled]="camera.isSubEnabled"
          [timestamp]="timestamp"
          [isFlv]="isFlv"
          [isFmp4Src]="hasFmp4"
          [alwaysOn]="alwaysOn"
          [camId]="camera.id"
          width="100%"
          [time]="time"
          (init)="onCloudPlayerInit($event)"
          (playerError)="onPlayerError($event)"
          (stateChange)="onStateChange($event)"
          (fullscreenChange)="onFullscreenChange($event)"
        >
          <sn-ptz-presets-component
            [ptzConfig]="ptzConfig"
            [class.hideWhilePtzDragging]="isPtzDragging"
          ></sn-ptz-presets-component>
          <sn-ptz-controls-component
            [ptzConfig]="ptzConfig"
            (dragging)="onPtzDrag($event)"
            *ngIf="
              isQognify ||
              camera.shareInfo?.permissionsDetails?.enablePtzControl ||
              !camera.isShared
            "
          >
          </sn-ptz-controls-component>
          <sn-video-player-analysis
            *ngIf="playerRef"
            (toggleCalendar)="toggleCalendar()"
            [camera]="camera"
            [alwaysOn]="alwaysOn"
            [ptzConfig]="ptzConfig"
            [class.hideWhilePtzDragging]="isPtzDragging"
          ></sn-video-player-analysis>
          <sn-player-footer-row
            class="camera-stream-view-mb-3"
            *ngIf="isLoadingTimeline && isFullscreen && !cameraTimeline"
          >
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <div class="timelineControls" [class.hideWhilePtzDragging]="isPtzDragging">
              <mat-calendar
                *ngIf="cameraTimeline && showCalendar && (isFullscreen || alwaysOn)"
                class="calendar availability"
                #calendar
                [(selected)]="date"
                [dateFilter]="hasRecordings"
                (selectedChange)="dateChange()"
              ></mat-calendar>
            </div>
            <fs-timeline
              class="videoPlayerTimeline"
              #recordingTimeline
              *ngIf="
                ((playerRef && cameraTimeline && isFullscreen && !isUbicquia) ||
                  alwaysOn ||
                  (showAvailableRecordings && isFullscreen && cameraTimeline)) &&
                !isLoadingTimeline
              "
              [currentTime]="time"
              [currentDate]="date"
              [height]="timelineHeight"
              [fullscreen]="isFullscreen"
              (dragging)="dragging($event)"
              (moveCursor)="moveCursor($event)"
              (brush)="onBrush($event)"
              [timelineDefinition]="cameraTimeline"
              (segment)="activateSegment($event)"
              (zoom)="onTimelineZoom($event)"
              (userSeeking)="onUserSeeking($event)"
              [prerecordingUrls]="camera.playbackUrls?.main?.cloud"
              [class.hideWhilePtzDragging]="isPtzDragging"
            >
            </fs-timeline>
            <sn-video-player-progress
              [class.showTimestamp]="
                camera.playbackUrls?.main?.cloud &&
                (!isFullscreen || (showAvailableRecordings && !cameraTimeline)) &&
                !alwaysOn &&
                !isUbicquia
              "
              [prerecordingUrls]="camera.playbackUrls?.main?.cloud"
              [liveUrls]="camera.liveVideoUrls"
            >
            </sn-video-player-progress>
          </sn-player-footer-row>
          <sn-player-footer-section>
            <sn-player-play-control></sn-player-play-control>
            <sn-player-volume-control></sn-player-volume-control>
            <sn-player-source-toggle-control
              [liveUrls]="camera.liveVideoUrls"
            ></sn-player-source-toggle-control>
            <sn-icon-button
              *ngIf="
                (!ptzOn && (isFullscreen || alwaysOn)) ||
                (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
              "
              [class.digiZoomActive]="isDigiZoomToggled"
              class="digiZoomToggle"
              (click)="toggleDigiZoom()"
              [matTooltip]="
                isDigiZoomToggled
                  ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                  : ('common.videoPlayer.toggleDigitalZoomOn' | t)
              "
            >
              <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
            </sn-icon-button>
            <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
            <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
              {{ time | fsFormatDate : 'long' }}
            </span>
            <div
              class="timelineLoadFailed"
              *ngIf="isFullscreen && !cameraTimeline && !isLoadingTimeline"
            >
              <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation"></sn-icon>
              <span class="ml-1">{{ 'cameras.stream.messages.timelineLoadFailed' | t }}</span>
              <sn-icon-button
                class="retryTimeline"
                (click)="retryTimeline()"
                [matTooltip]="'cameras.stream.tooltips.reloadTimeline' | t"
              >
                <sn-icon fontSet="far" fontIcon="fa-repeat"></sn-icon>
              </sn-icon-button>
            </div>
          </sn-player-footer-section>
          <sn-player-footer-section alignment="end">
            <div class="gauge" *ngIf="!playerRef?.live && isFullscreen && playerRef?.play">
              <sn-icon class="fa-solid fa-gauge-low"></sn-icon>
              <mat-slider
                *ngIf="
                  cloudPlayerRef.reference &&
                  !playerRef?.live &&
                  playerRef?.play &&
                  (isFullscreen || alwaysOn)
                "
                [matTooltip]="'common.videoPlayer.playbackRate' | t"
                matTooltipPosition="left"
                [displayWith]="getLabel"
                [thumbLabel]="true"
                [tickInterval]="0.1"
                [step]="0.1"
                [min]="0.1"
                [max]="2"
                [value]="cloudPlayerRef.reference.playbackRate"
                [(ngModel)]="cloudPlayerRef.reference.playbackRate"
              >
              </mat-slider>
              <sn-icon class="fa-solid fa-gauge-high"> </sn-icon>
            </div>
            <sn-icon
              *ngIf="isFullscreen && canEdit"
              (click)="reportCameraIssue(camera.id)"
              matTooltipPosition="above"
              [matTooltip]="'common.reportCameraIssue' | t"
              class="indicator warning"
              fontSet="fa"
              fontIcon="fa-triangle-exclamation"
            >
            </sn-icon>
            <mat-chip
              class="matChip"
              *ngIf="isFullscreen && camera.isShared"
              [matTooltip]="'cameras.stream.labels.sharedOrganization' | t"
              matTooltipPosition="above"
            >
              <div matChipAvatar>
                <div
                  class="colorIndicator"
                  [ngStyle]="{ 'background-color': camera?.shareInfo?.settings?.color }"
                ></div>
              </div>
              {{ camera.organization.name }}
            </mat-chip>
            <span
              *ngIf="!isFullscreen && camera.isShared"
              [ngStyle]="{ 'background-color': camera?.shareInfo?.settings?.color }"
              class="colorIndicator"
            ></span>
            <sn-icon-button
              class="citizen-popup"
              *ngIf="!isFullscreen && camera.isCitizen"
              [matTooltip]="'cameras.stream.tooltips.openPopup' | t"
              (click)="openCitizenPopup()"
            >
              <sn-icon fontSet="far" fontIcon="fa-circle-info"></sn-icon>
            </sn-icon-button>
            <sn-icon class="indicator cloud" fontSet="fa" fontIconUnicode="f0c2"></sn-icon>
            <sn-player-fullscreen-control></sn-player-fullscreen-control>
          </sn-player-footer-section>
        </sn-video-player>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="isUnmanagedStreamActive && !!camera.unmanagedLiveUrls">
    <sn-video-player
      #unmanagedPlayerRef
      [autoplay]="autoplay"
      [camera]="camera"
      [caption]="caption"
      [elevation]="camera.elevation"
      [live]="true"
      [muted]="true"
      [controls]="controls"
      [aspectRatio]="ASPECT_RATIO.Classic"
      width="100%"
      [src]="camera.unmanagedLiveUrls"
      [cloudTimeout]="false"
      [timestamp]="timestamp"
      [isFlv]="isFlv"
      [isFmp4Src]="hasFmp4"
      [camId]="camera.id"
      [alwaysOn]="alwaysOn"
      [time]="time"
      (init)="onPlayerInit($event)"
      (stateChange)="onStateChange($event)"
      (fullscreenChange)="onFullscreenChange($event)"
    >
      <sn-video-player-analysis *ngIf="playerRef" [camera]="camera" [ptzConfig]="ptzConfig">
      </sn-video-player-analysis>
      <sn-player-footer-row>
        <sn-player-footer-section>
          <sn-player-play-control></sn-player-play-control>
          <sn-player-volume-control></sn-player-volume-control>
          <sn-player-source-toggle-control
            [liveUrls]="camera.unmanagedLiveUrls"
          ></sn-player-source-toggle-control>
          <sn-icon-button
            *ngIf="
              (!ptzOn && (isFullscreen || alwaysOn)) ||
              (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
            "
            [class.digiZoomActive]="isDigiZoomToggled"
            class="digiZoomToggle"
            (click)="toggleDigiZoom()"
            [matTooltip]="
              isDigiZoomToggled
                ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                : ('common.videoPlayer.toggleDigitalZoomOn' | t)
            "
          >
            <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
          </sn-icon-button>
          <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
          <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
            {{ time | fsFormatDate : 'long' }}
          </span>
        </sn-player-footer-section>
        <sn-player-footer-section alignment="end">
          <mat-slider
            *ngIf="
              unManagedPlayerRef?.reference &&
              !playerRef?.live &&
              playerRef?.play &&
              (isFullscreen || alwaysOn)
            "
            matTooltip="{{ 'common.videoPlayer.playbackRate' | t }}"
            matTooltipPosition="left"
            class="playback-rate"
            [displayWith]="getLabel"
            [thumbLabel]="true"
            [tickInterval]="0.1"
            [step]="0.1"
            [min]="0.1"
            [max]="2"
            [value]="unManagedPlayerRef.reference.playbackRate"
            [(ngModel)]="unManagedPlayerRef.reference.playbackRate"
          >
          </mat-slider>
          <sn-icon
            *ngIf="isFullscreen && canEdit"
            (click)="reportCameraIssue(camera.id)"
            matTooltipPosition="above"
            [matTooltip]="'common.reportCameraIssue' | t"
            class="indicator warning"
            fontSet="fa"
            fontIcon="fa-triangle-exclamation"
          >
          </sn-icon>
          <sn-player-fullscreen-control></sn-player-fullscreen-control>
        </sn-player-footer-section>
      </sn-player-footer-row>
    </sn-video-player>
  </ng-template>

  <ng-template [ngIf]="!isUnmanagedStreamActive && !!camera.liveVideoUrls && hasFmp4 && !isJpeg">
    <div class="players">
      <div class="localPlayer player">
        <sn-video-player
          *ngIf="!!src"
          #localPlayerRef
          [autoplay]="autoplay"
          [src]="src"
          [camera]="camera"
          [caption]="caption"
          [elevation]="camera.elevation"
          [live]="true"
          [muted]="true"
          [loopDuration]="camera.loopDuration"
          [controls]="controls"
          [aspectRatio]="ASPECT_RATIO.Classic"
          [local]="true"
          [cloudTimeout]="cloudTimeout"
          [subEnabled]="true"
          [timestamp]="timestamp"
          [isFlv]="isFlv"
          [alwaysOn]="alwaysOn"
          [isFususCamera]="isFususCamera"
          [isFmp4Src]="hasFmp4"
          [camId]="camera.id"
          [ptzConfig]="ptzConfig"
          width="100%"
          [time]="time"
          (init)="onLocalPlayerInit($event)"
          (stateChange)="externalStateChange($event)"
          (fullscreenChange)="onFullscreenChange($event)"
          (playerError)="onPlayerError($event)"
        >
          <sn-ptz-presets-component
            [ptzConfig]="ptzConfig"
            [local]="true"
            [isExternalPtz]="true"
          ></sn-ptz-presets-component>
          <sn-ptz-controls-component
            [ptzConfig]="ptzConfig"
            [isExternalPtz]="true"
            [local]="true"
            *ngIf="camera.shareInfo?.permissionsDetails?.enablePtzControl || !camera.isShared"
          ></sn-ptz-controls-component>
          <sn-player-footer-row
            class="camera-stream-view-mb-3"
            *ngIf="isLoadingTimeline && isFullscreen && !cameraTimeline"
          >
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <fs-timeline
              class="videoPlayerTimeline"
              #recordingTimeline
              *ngIf="
                (((camera.playbackUrls?.main?.local || camera.prerecordingUrls?.timeline) &&
                  cameraTimeline &&
                  isFullscreen &&
                  !isUbicquia) ||
                  alwaysOn ||
                  (showAvailableRecordings && isFullscreen && cameraTimeline)) &&
                !isLoadingTimeline
              "
              [currentTime]="time"
              [currentDate]="date"
              [fullscreen]="isFullscreen"
              (dragging)="dragging($event)"
              (moveCursor)="moveCursor($event)"
              (brush)="onBrush($event)"
              [timelineDefinition]="cameraTimeline"
              [height]="timelineHeight"
              (segment)="activateSegment($event)"
              (zoom)="onTimelineZoom($event)"
              (userSeeking)="onUserSeeking($event)"
              [prerecordingUrls]="
                isExternalAvigilon
                  ? camera.prerecordingUrls.timeline[0]
                  : camera.playbackUrls?.main?.local
              "
            >
            </fs-timeline>
            <div class="timelineControls">
              <mat-calendar
                *ngIf="cameraTimeline && showCalendar && (isFullscreen || alwaysOn)"
                class="calendar availability"
                #calendar
                [(selected)]="date"
                [dateFilter]="hasRecordings"
                (selectedChange)="dateChange()"
              ></mat-calendar>
            </div>
          </sn-player-footer-row>
          <sn-player-footer-section>
            <sn-player-play-control></sn-player-play-control>
            <sn-player-volume-control></sn-player-volume-control>
            <sn-player-source-toggle-control
              [liveUrls]="camera.liveVideoUrls"
            ></sn-player-source-toggle-control>
            <sn-icon-button
              *ngIf="
                (!ptzOn && (isFullscreen || alwaysOn)) ||
                (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
              "
              [class.digiZoomActive]="isDigiZoomToggled"
              class="digiZoomToggle"
              (click)="toggleDigiZoom()"
              [matTooltip]="
                isDigiZoomToggled
                  ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                  : ('common.videoPlayer.toggleDigitalZoomOn' | t)
              "
            >
              <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
            </sn-icon-button>
            <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
            <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
              {{ time | fsFormatDate : 'long' }}
            </span>
            <div
              class="timelineLoadFailed"
              *ngIf="isFullscreen && !cameraTimeline && !isLoadingTimeline"
            >
              <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation"></sn-icon>
              <span class="ml-1">{{ 'cameras.stream.messages.timelineLoadFailed' | t }}</span>
              <sn-icon-button
                class="retryTimeline"
                (click)="retryTimeline()"
                [matTooltip]="'cameras.stream.tooltips.reloadTimeline' | t"
              >
                <sn-icon fontSet="far" fontIcon="fa-repeat"></sn-icon>
              </sn-icon-button>
            </div>
          </sn-player-footer-section>
          <sn-player-footer-section alignment="end">
            <div class="gauge" *ngIf="!playerRef?.live && isFullscreen">
              <sn-icon class="fa-solid fa-gauge-low"></sn-icon>
              <mat-slider
                *ngIf="
                  localPlayerRef.reference &&
                  !playerRef?.live &&
                  playerRef?.play &&
                  (isFullscreen || alwaysOn)
                "
                [matTooltip]="'common.videoPlayer.playbackRate' | t"
                matTooltipPosition="left"
                [displayWith]="getLabel"
                [thumbLabel]="true"
                [tickInterval]="0.1"
                [step]="0.1"
                [min]="0.1"
                [max]="2"
                [value]="localPlayerRef.reference.playbackRate"
                [(ngModel)]="localPlayerRef.reference.playbackRate"
              >
              </mat-slider>
              <sn-icon class="fa-solid fa-gauge-high"> </sn-icon>
            </div>
            <sn-icon
              *ngIf="isFullscreen && canEdit"
              (click)="reportCameraIssue(camera.id)"
              matTooltipPosition="above"
              [matTooltip]="'common.reportCameraIssue' | t"
              class="indicator warning"
              fontSet="fa"
              fontIcon="fa-triangle-exclamation"
            >
            </sn-icon>
            <sn-icon class="indicator local" fontSet="fa" fontIconUnicode="f6ff"></sn-icon>
            <sn-icon class="indicator external">alt_route</sn-icon>
            <sn-player-fullscreen-control></sn-player-fullscreen-control>
          </sn-player-footer-section>
        </sn-video-player>
      </div>
      <div
        class="cloudPlayer player"
        *ngIf="!localPlaying"
        [class.noLocalStream]="!src?.main?.local"
      >
        <sn-video-player
          #cloudPlayerRef
          [autoplay]="autoplay"
          [src]="src"
          [camera]="camera"
          [caption]="caption"
          [elevation]="camera.elevation"
          [live]="true"
          [muted]="true"
          [loopDuration]="camera.loopDuration"
          [controls]="controls"
          [aspectRatio]="ASPECT_RATIO.Classic"
          [local]="false"
          [cloudTimeout]="cloudTimeout"
          [subEnabled]="camera.isSubEnabled"
          [timestamp]="timestamp"
          [isFlv]="isFlv"
          [ptzConfig]="ptzConfig"
          [isFmp4Src]="hasFmp4"
          [alwaysOn]="alwaysOn"
          [camId]="camera.id"
          width="100%"
          [time]="time"
          (init)="onCloudPlayerInit($event)"
          (stateChange)="externalStateChange($event)"
          (fullscreenChange)="onFullscreenChange($event)"
          (playerError)="onPlayerError($event)"
        >
          <sn-ptz-presets-component
            [ptzConfig]="ptzConfig"
            [local]="false"
            [isExternalPtz]="true"
          ></sn-ptz-presets-component>
          <sn-ptz-controls-component
            [ptzConfig]="ptzConfig"
            [isExternalPtz]="true"
            [local]="false"
            *ngIf="camera.shareInfo?.permissionsDetails?.enablePtzControl || !camera.isShared"
          ></sn-ptz-controls-component>
          <div class="timelineControls">
            <mat-calendar
              *ngIf="cameraTimeline && showCalendar && (isFullscreen || alwaysOn)"
              class="calendar availability"
              #calendar
              [(selected)]="date"
              [dateFilter]="hasRecordings"
              (selectedChange)="dateChange()"
            ></mat-calendar>
          </div>
          <sn-player-footer-row
            class="camera-stream-view-mb-3"
            *ngIf="isLoadingTimeline && isFullscreen && !cameraTimeline"
          >
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
          </sn-player-footer-row>
          <sn-player-footer-row>
            <fs-timeline
              class="videoPlayerTimeline"
              #recordingTimeline
              *ngIf="
                (((camera.playbackUrls?.main?.cloud || camera.prerecordingUrls.timeline) &&
                  cameraTimeline &&
                  isFullscreen &&
                  !isUbicquia) ||
                  alwaysOn ||
                  (showAvailableRecordings && isFullscreen && cameraTimeline)) &&
                !isLoadingTimeline
              "
              [currentTime]="time"
              [currentDate]="date"
              [fullscreen]="isFullscreen"
              (dragging)="dragging($event)"
              (moveCursor)="moveCursor($event)"
              (brush)="onBrush($event)"
              [timelineDefinition]="cameraTimeline"
              [height]="timelineHeight"
              (segment)="activateSegment($event)"
              (zoom)="onTimelineZoom($event)"
              (userSeeking)="onUserSeeking($event)"
              [prerecordingUrls]="
                isExternalAvigilon
                  ? camera.prerecordingUrls.timeline[0]
                  : camera.playbackUrls?.main?.cloud
              "
            >
            </fs-timeline>
          </sn-player-footer-row>
          <sn-player-footer-section>
            <sn-player-play-control></sn-player-play-control>
            <sn-player-volume-control></sn-player-volume-control>
            <sn-player-source-toggle-control
              [liveUrls]="camera.liveVideoUrls"
            ></sn-player-source-toggle-control>
            <sn-icon-button
              *ngIf="
                (!ptzOn && (isFullscreen || alwaysOn)) ||
                (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
              "
              [class.digiZoomActive]="isDigiZoomToggled"
              class="digiZoomToggle"
              (click)="toggleDigiZoom()"
              [matTooltip]="
                isDigiZoomToggled
                  ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
                  : ('common.videoPlayer.toggleDigitalZoomOn' | t)
              "
            >
              <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
            </sn-icon-button>
            <sn-icon-button
              [matTooltip]="'common.videoPlayer.takeScreenshot' | t"
              (click)="screenshot()"
              *ngIf="isFullscreen"
            >
              <sn-icon>content_cut</sn-icon>
            </sn-icon-button>
            <sn-icon-button
              [matTooltip]="'cameras.stream.tooltips.toggleCalendar' | t"
              (click)="toggleCalendar()"
              *ngIf="isFullscreen"
            >
              <sn-icon>date_range</sn-icon>
            </sn-icon-button>
            <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
            <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
              {{ time | fsFormatDate : 'long' }}
            </span>
            <div
              class="timelineLoadFailed"
              *ngIf="isFullscreen && !cameraTimeline && !isLoadingTimeline"
            >
              <sn-icon fontSet="fal" fontIcon="fa-circle-exclamation"></sn-icon>
              <span class="ml-1">{{ 'cameras.stream.messages.timelineLoadFailed' | t }}</span>
              <sn-icon-button
                class="retryTimeline"
                (click)="retryTimeline()"
                [matTooltip]="'cameras.stream.tooltips.reloadTimeline' | t"
              >
                <sn-icon fontSet="far" fontIcon="fa-repeat"></sn-icon>
              </sn-icon-button>
            </div>
          </sn-player-footer-section>
          <sn-player-footer-section alignment="end">
            <div class="gauge" *ngIf="!playerRef?.live && isFullscreen">
              <sn-icon class="fa-solid fa-gauge-low"></sn-icon>
              <mat-slider
                *ngIf="
                  cloudPlayerRef.reference &&
                  !playerRef?.live &&
                  playerRef?.play &&
                  (isFullscreen || alwaysOn)
                "
                [matTooltip]="'common.videoPlayer.playbackRate' | t"
                matTooltipPosition="left"
                [displayWith]="getLabel"
                [thumbLabel]="true"
                [tickInterval]="0.1"
                [step]="0.1"
                [min]="0.1"
                [max]="2"
                [value]="cloudPlayerRef.reference.playbackRate"
                [(ngModel)]="cloudPlayerRef.reference.playbackRate"
              >
              </mat-slider>
              <sn-icon class="fa-solid fa-gauge-high"> </sn-icon>
            </div>
            <sn-icon
              *ngIf="isFullscreen && canEdit"
              (click)="reportCameraIssue(camera.id)"
              matTooltipPosition="above"
              [matTooltip]="'common.reportCameraIssue' | t"
              class="indicator warning"
              fontSet="fa"
              fontIcon="fa-triangle-exclamation"
            >
            </sn-icon>
            <sn-icon class="indicator cloud" fontSet="fa" fontIconUnicode="f0c2"></sn-icon>
            <sn-icon class="indicator external">alt_route</sn-icon>
            <sn-player-fullscreen-control></sn-player-fullscreen-control>
          </sn-player-footer-section>
        </sn-video-player>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="(isUnmanagedStreamActive && !camera.unmanagedLiveUrls) || isJpeg">
    <sn-image-player
      #unmanagedPlayerRef
      [autoplay]="autoplay"
      [src]="frameSrc"
      [caption]="caption"
      [elevation]="camera.elevation"
      [controls]="controls"
      [aspectRatio]="ASPECT_RATIO.Classic"
      [refreshTime]="camera.unmanagedParams.refreshTime"
      width="100%"
      (init)="onPlayerInit($event)"
    >
      <sn-player-footer-section>
        <sn-player-play-control></sn-player-play-control>
        <sn-icon-button
          *ngIf="
            (!ptzOn && (isFullscreen || alwaysOn)) ||
            (isPtzDigiZoomEnabled && (isFullscreen || alwaysOn))
          "
          [class.digiZoomActive]="isDigiZoomToggled"
          class="digiZoomToggle"
          (click)="toggleDigiZoom()"
          [matTooltip]="
            isDigiZoomToggled
              ? ('common.videoPlayer.toggleDigitalZoomOff' | t)
              : ('common.videoPlayer.toggleDigitalZoomOn' | t)
          "
        >
          <sn-icon fontSet="far" fontIcon="fa-search"></sn-icon>
        </sn-icon-button>
        <!-- TODO : For timestamp translation https://taserintl.atlassian.net/browse/FWX-3069 -->
        <span class="camTimeStamp" *ngIf="isFullscreen || alwaysOn">
          {{ time | fsFormatDate : 'long' }}
        </span>
      </sn-player-footer-section>
      <sn-player-footer-section alignment="end">
        <sn-player-fullscreen-control></sn-player-fullscreen-control>
      </sn-player-footer-section>
    </sn-image-player>
  </ng-template>
</ng-template>
